import {useMutation} from "@tanstack/react-query";

import {restoreLeadMutationOptions} from "./restore-lead.mutation-options";

export function useRestoreLead() {
  return useMutation(restoreLeadMutationOptions());
}
